// extracted by mini-css-extract-plugin
export default {"icon_addon":"j19osizQzml0_73jEKLm"};